import CryptoJS from 'crypto-js';

// 加密
export const encrypt = (text,key)=> {
  return CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString();
}

// 解密
export const decrypt = (text, key)=> {
  return CryptoJS.AES.decrypt(text, CryptoJS.enc.Utf8.parse(key), {
    // iv:iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString(CryptoJS.enc.Utf8);
}


// WEBPACK FOOTER //
// ./src/utils/crypto.js